import React from "react";

import { faFileTimes, faUserClock } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import { HighlightContext } from "~/calendar/CalendarPage";
import { dispatchAnalyticsTrack } from "~/lib/segment";

import baseStyles from "./BasePanel.module.css";
import styles from "./MeetingsHealth.module.css";

export default function MeetingsHealth() {
	const {
		noAgendaMeetingsCount,
		isOrganizerMeetingsCount,
		highlightNoAgenda,
		toggleHighlightNoAgenda: _toggleHighlightNoAgenda,
		highlightOrganized,
		toggleHighlightOrganized: _toggleHighlightOrganized,
	} = React.useContext(HighlightContext);

	const toggleHighlightNoAgenda = React.useCallback(() => {
		_toggleHighlightNoAgenda();
		dispatchAnalyticsTrack("Meeting health", {
			feature: "Calendar",
			action: "toggleHighlightNoAgenda",
			value: !highlightNoAgenda,
		});
	}, [_toggleHighlightNoAgenda, highlightNoAgenda]);

	const toggleHighlightOrganized = React.useCallback(() => {
		_toggleHighlightOrganized();
		dispatchAnalyticsTrack("Meeting health", {
			feature: "Calendar",
			action: "toggleHighlightOrganized",
			value: !highlightOrganized,
		});
	}, [_toggleHighlightOrganized, highlightOrganized]);

	return (
		<div>
			<div className={baseStyles.header}>Meeting filters…</div>
			<div className={styles.items}>
				<div className={cx(styles.item, { [styles.checked]: highlightNoAgenda })} onClick={toggleHighlightNoAgenda}>
					<FontAwesomeIcon icon={faFileTimes} className={styles.icon} />
					<div>
						No agenda
						{noAgendaMeetingsCount > 0 && ` (${noAgendaMeetingsCount})`}
					</div>
				</div>

				<div
					className={cx(styles.item, { [styles.checked]: highlightOrganized })}
					onClick={toggleHighlightOrganized}
					title="Meetings with 2+ participants"
				>
					<FontAwesomeIcon icon={faUserClock} className={styles.icon} />
					<div>
						Meetings I organize
						{isOrganizerMeetingsCount > 0 && ` (${isOrganizerMeetingsCount})`}
					</div>
				</div>
			</div>
		</div>
	);
}
